import { ApplicationState, WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { getCurrentEnterpriseId, hasPlatformPrivilege } from '@mews-commander/core';
import { getEnterpriseIdFromServiceId } from '../../ducks/services';
import { hasPlatformAdminScope, hasPlatformScopeWithAccessAllEnterprises } from '../../ducks/scopes';
import { getCurrentEnterpriseRelatedTargetEnterprisesId } from '../enterprises';

export const checkServicePrivilege = (state: ApplicationState, { serviceId }: WithServiceId) => {
    const enterpriseId = getCurrentEnterpriseId();
    const isCorrectEnterpriseId = enterpriseId === getEnterpriseIdFromServiceId(state, { serviceId });
    return isCorrectEnterpriseId || hasPlatformScopeWithAccessAllEnterprises(state) || hasPlatformAdminScope(state);
};

export const checkEnterprisePrivilege = (state: ApplicationState, { enterpriseId }: WithEnterpriseId) =>
    enterpriseId === getCurrentEnterpriseId() ||
    getCurrentEnterpriseRelatedTargetEnterprisesId(state).includes(enterpriseId) ||
    hasPlatformPrivilege('accessAllEnterprises') ||
    hasPlatformPrivilege('admin');
